import type {
  GetAffiliatesListWithStatsResponse,
  GetAffiliatesListWithStatsData,

  GetAffiliatesData,
  GetAffiliatesResponse,

  GetAffiliateNotificationsData,
  GetAffiliateNotificationsResponse,

  GetAffiliateNotificationsByIdAffiliatesData,
  GetAffiliateNotificationsByIdAffiliatesResponse,

  PostAffiliateNotificationsData,
  PostAffiliateNotificationsResponse,

  GetAffiliatesByIdData,
  GetAffiliatesByIdResponse,

  PutAffiliatesByIdData,
  PutAffiliatesByIdResponse,

  PostWalletsSwitchData,
  PostWalletsSwitchResponse,

  GetWalletsByIdHistoryData,
  GetWalletsByIdHistoryResponse,

  GetWalletsByIdHistoryCountData,
  GetWalletsByIdHistoryCountResponse,

  PostWalletsByIdChangeBalanceData,
  PostWalletsByIdChangeBalanceResponse,

  PostAffiliatesByIdUpdatePasswordData,
  PostAffiliatesByIdUpdatePasswordResponse,

  PostAffiliatesByIdUpdateReferralProgramData,
  PostAffiliatesByIdUpdateReferralProgramResponse,

  PostAffiliatesByIdMassAttachSubAffiliatesData,
  PostAffiliatesByIdMassAttachSubAffiliatesResponse,

  GetAffiliatesByIdMassAttachSubAffiliatesAvailableSubAffiliatesData,
  GetAffiliatesByIdMassAttachSubAffiliatesAvailableSubAffiliatesResponse,

  PostAffiliatesByIdUpdateLimitsData,
  PostAffiliatesByIdUpdateLimitsResponse,

  PostAffiliatesByIdUpdatePaymentMethodData,
  PostAffiliatesByIdUpdatePaymentMethodResponse,

  PostAffiliatesByIdUpdateDomainChangeNotificationsSettingsData,
  PostAffiliatesByIdUpdateDomainChangeNotificationsSettingsResponse,

  GetActivityLogData,
  GetActivityLogResponse,

  GetActivityLogCountData,
  GetActivityLogCountResponse,

  PostAffiliatesByIdUpdateReportingSettingsData,
  PostAffiliatesByIdUpdateReportingSettingsResponse,

  PostAffiliatesByIdUpdateMediaBuyingSettingsData,
  PostAffiliatesByIdUpdateMediaBuyingSettingsResponse,

  GetAffiliatesByIdMultiaccountsData,
  GetAffiliatesByIdMultiaccountsResponse,

  PostAffiliatesByIdApproveData,
  PostAffiliatesByIdApproveResponse,

  PostAffiliatesByIdRejectData,
  PostAffiliatesByIdRejectResponse,

  GetWalletsData,
  GetWalletsResponse,

  GetWalletsSwitchAvailableCurrenciesData,
  GetWalletsSwitchAvailableCurrenciesResponse,

  PostAffiliatesByIdBlockData,
  PostAffiliatesByIdBlockResponse,

  PostAffiliatesByIdUnblockData,
  PostAffiliatesByIdUnblockResponse,

  PostAffiliatesByIdRevokeApproveData,
  PostAffiliatesByIdRevokeApproveResponse,

  PostAffiliatesByIdManualEmailVerificationData,
  PostAffiliatesByIdManualEmailVerificationResponse,

  PostAffiliatesByIdCreatePaymentData,
  PostAffiliatesByIdCreatePaymentResponse,

  PostAffiliatesByIdResetTotpData,
  PostAffiliatesByIdResetTotpResponse,

  PostAffiliatesByIdUpdateEmailData,
  PostAffiliatesByIdUpdateEmailResponse,

  GetAffiliatesByIdTrafficBlockResponse,
  PutAffiliatesByIdTrafficBlockData,
  PutAffiliatesByIdTrafficBlockResponse,
  DeleteAffiliatesByIdTrafficBlockResponse,

  GetAffiliatesByIdPaymentsReportData,
  GetAffiliatesByIdPaymentsReportResponse,

  GetAffiliatesByIdPaymentsReportCpaPlayersData,
  GetAffiliatesByIdPaymentsReportCpaPlayersResponse,

  GetAffiliateNotesData,
  GetAffiliateNotesResponse,

  PostAffiliateNotesData,
  PostAffiliateNotesResponse,

  PutAffiliateNotesByIdData,
  PutAffiliateNotesByIdResponse,

  DeleteAffiliateNotesByIdData,
  DeleteAffiliateNotesByIdResponse,

  GetAffiliatesByIdRotationGroupsData,
  GetAffiliatesByIdRotationGroupsResponse,

  PostAffiliatesByIdRotationGroupsData,
  PostAffiliatesByIdRotationGroupsResponse,

  DeleteAffiliatesByIdRotationGroupsBySecondaryRotationGroupIdData,
  DeleteAffiliatesByIdRotationGroupsBySecondaryRotationGroupIdResponse,

  PostAffiliatesByIdRotationGroupsBySecondaryRotationGroupIdSetAsPrimaryData,
  PostAffiliatesByIdRotationGroupsBySecondaryRotationGroupIdSetAsPrimaryResponse,

  PostAffiliatesRearrangeReferralProgramData,
  PostAffiliatesRearrangeReferralProgramResponse,

  PostAffiliatesRearrangeReferralProgramCountData,
  PostAffiliatesRearrangeReferralProgramCountResponse,

  PostAffiliatesRearrangeReferralProgramAvailableAffiliatesData,
  PostAffiliatesRearrangeReferralProgramAvailableAffiliatesResponse,

  GetAffiliatesByIdUpdateReferralProgramAvailableAffiliatesData,
  GetAffiliatesByIdUpdateReferralProgramAvailableAffiliatesResponse,

  PutAffiliatesByIdPublicProfileData,
  PutAffiliatesByIdPublicProfileResponse,

  DeleteAffiliatesByIdPublicProfileData,
  DeleteAffiliatesByIdPublicProfileResponse,

  GetAffiliateKpiBonusesData,
  GetAffiliateKpiBonusesResponse,

  PostAffiliateKpiBonusesData,
  PostAffiliateKpiBonusesResponse,

  PutAffiliateKpiBonusesByIdData,
  PutAffiliateKpiBonusesByIdResponse,

  PostAffiliateKpiBonusesByIdCancelData,
  PostAffiliateKpiBonusesByIdCancelResponse,

  GetAffiliateKpiBonusesAvailableTypesData,
  GetAffiliateKpiBonusesAvailableTypesResponse,

  GetAffiliateMonitoringData,
  GetAffiliateMonitoringResponse,

  PostAffiliateMonitoringData,
  PostAffiliateMonitoringResponse,

  DeleteAffiliateMonitoringByIdData,
  DeleteAffiliateMonitoringByIdResponse,

  PutAffiliateMonitoringByIdData,
  PutAffiliateMonitoringByIdResponse,
  PostAffiliatesByIdRequestKycResponses,
  PostAffiliatesByIdRequestKycResponse,
  PostAffiliatesByIdSkipKycResponse,
} from '@/types/openapi-ts';
import type { AxiosInstance } from "axios";

export function getAffiliatesApiModule(affiliatesApi: AxiosInstance) {
  return {
    // getTempPanelToken(id) {
    //   return this.affiliatesApi.get(`/affiliates/${id}/temporary-access-token`);
    // },
    // getOldPanelLogin(id) {
    //   return this.affiliatesApi.get(`/affiliates/${id}/old-panel-login-url`);
    // },

    // list
    getAffiliates(params: GetAffiliatesData['query']) {
      return affiliatesApi.get<GetAffiliatesResponse>('/affiliates', { params });
    },
    getAffiliatesWithStats(params: GetAffiliatesListWithStatsData['query']) {
      return affiliatesApi.get<GetAffiliatesListWithStatsResponse>('/affiliates/list-with-stats', { params });
    },
    getAffiliatesNotifications(params: GetAffiliateNotificationsData['query']) {
      return affiliatesApi.get<GetAffiliateNotificationsResponse>('/affiliate-notifications', { params });
    },
    getAffiliateNotificationsById(id: string, params: GetAffiliateNotificationsByIdAffiliatesData['query']) {
      return affiliatesApi.get<GetAffiliateNotificationsByIdAffiliatesResponse>(`/affiliate-notifications/${id}/affiliates`, { params });
    },
    postAffiliatesNotifications(payload: PostAffiliateNotificationsData['body']) {
      return affiliatesApi.post<PostAffiliateNotificationsResponse>('/affiliate-notifications', payload);
    },

    // info
    getAffiliateInfo(id: string) {
      return affiliatesApi.get<GetAffiliatesByIdResponse>(`/affiliates/${id}`);
    },
    putAffiliateInfo(id: string, payload: PutAffiliatesByIdData['body']) {
      return affiliatesApi.put<PutAffiliatesByIdResponse>(`/affiliates/${id}`, payload);
    },

    getAffiliateWallets(id: string) {
      return affiliatesApi.get<GetWalletsResponse>(`/wallets?affiliate_id=${id}`);
    },
    getAffiliateWalletsAvailableToSwitch(id: string) {
      return affiliatesApi.get<GetWalletsSwitchAvailableCurrenciesResponse>(`/wallets/switch/available-currencies?affiliate_id=${id}`);
    },
    postAffiliateSwitchWallet(params: PostWalletsSwitchData['body']) {
      const { affiliate_id, currency_code } = params;
      return affiliatesApi.post<PostWalletsSwitchResponse>('/wallets/switch', { affiliate_id, currency_code });
    },
    getAffiliateWalletHistory(id: string, params: GetWalletsByIdHistoryData['query']) {
      return affiliatesApi.get<GetWalletsByIdHistoryResponse>(`/wallets/${id}/history`, { params });
    },
    getAffiliateWalletHistoryCount(id: string, params: GetWalletsByIdHistoryCountData['query']) {
      return affiliatesApi.get<GetWalletsByIdHistoryCountResponse>(`/wallets/${id}/history/count`, { params });
    },
    changeBalance(id: string, payload: PostWalletsByIdChangeBalanceData['body']) {
      return affiliatesApi.post<PostWalletsByIdChangeBalanceResponse>(`/wallets/${id}/change-balance`, payload);
    },
    resetAffiliatePassword(id: string, pwd: PostAffiliatesByIdUpdatePasswordData['body']) {
      return affiliatesApi.post<PostAffiliatesByIdUpdatePasswordResponse>(`/affiliates/${id}/update-password`, {
        new_password: pwd,
      });
    },
    updateAffiliateReferral(id: string, payload: PostAffiliatesByIdUpdateReferralProgramData['body']) {
      return affiliatesApi.post<PostAffiliatesByIdUpdateReferralProgramResponse>(`/affiliates/${id}/update-referral-program`, payload);
    },
    updateAffiliateReferralMass(id: string, payload: PostAffiliatesByIdMassAttachSubAffiliatesData['body']) {
      return affiliatesApi.post<PostAffiliatesByIdMassAttachSubAffiliatesResponse>(`/affiliates/${id}/mass-attach-sub-affiliates`, {
        referral_id: payload,
      });
    },
    getAffiliateMassAttach(id: string, params: GetAffiliatesByIdMassAttachSubAffiliatesAvailableSubAffiliatesData['query']) {
      return affiliatesApi.get<GetAffiliatesByIdMassAttachSubAffiliatesAvailableSubAffiliatesResponse>(
        `/affiliates/${id}/mass-attach-sub-affiliates/available-sub-affiliates`, { params }
      );
    },

    updateAffiliateLimits(id: string, payload: PostAffiliatesByIdUpdateLimitsData['body']) {
      return affiliatesApi.post<PostAffiliatesByIdUpdateLimitsResponse>(`/affiliates/${id}/update-limits`, payload);
    },
    // updateAffiliateCommissions(id: string, payload: ) {
    //   return affiliatesApi.post(`/affiliates/${id}/update-commissions`, payload);
    // },
    updateAffiliatePayment(id: string, payload: PostAffiliatesByIdUpdatePaymentMethodData['body']) {
      return affiliatesApi.post<PostAffiliatesByIdUpdatePaymentMethodResponse>(`/affiliates/${id}/update-payment-method`, payload);
    },
    updateAffiliateNotificationsSettings(id: string, payload: PostAffiliatesByIdUpdateDomainChangeNotificationsSettingsData['body']) {
      return affiliatesApi.post<PostAffiliatesByIdUpdateDomainChangeNotificationsSettingsResponse>(
        `/affiliates/${id}/update-domain-change-notifications-settings`, payload
      );
    },
    getAffiliateActivity(params: GetActivityLogData['query']) {
      return affiliatesApi.get<GetActivityLogResponse>('/activity-log', { params });
    },
    getAffiliateActivityCount(params: GetActivityLogCountData['query']) {
      return affiliatesApi.get<GetActivityLogCountResponse>('/activity-log/count', { params });
    },
    updateAffiliatReportingOptions(id: string, payload: PostAffiliatesByIdUpdateReportingSettingsData) {
      return affiliatesApi.post<PostAffiliatesByIdUpdateReportingSettingsResponse>(`/affiliates/${id}/update-reporting-settings`, payload);
    },
    updateAffiliatMediaBuyingOptions(id: string, payload: PostAffiliatesByIdUpdateMediaBuyingSettingsData['body']) {
      return affiliatesApi.post<PostAffiliatesByIdUpdateMediaBuyingSettingsResponse>(`/affiliates/${id}/update-media-buying-settings`, payload);
    },
    getAffiliateMultiaccounts(id: string) {
      return affiliatesApi.get<GetAffiliatesByIdMultiaccountsResponse>(`/affiliates/${id}/multiaccounts`);
    },

    // affiliate status
    approveAffiliate(id: string, payload: PostAffiliatesByIdApproveData['body']) {
      return affiliatesApi.post<PostAffiliatesByIdApproveResponse>(`/affiliates/${id}/approve`, payload);
    },
    rejectAffiliate(id: string, withNotification: boolean) {
      return affiliatesApi.post<PostAffiliatesByIdRejectResponse>(`/affiliates/${id}/reject?with_notification=${withNotification}`);
    },
    blockAffiliate(id: string) {
      return affiliatesApi.post<PostAffiliatesByIdBlockResponse>(`/affiliates/${id}/block`);
    },
    unblockAffiliate(id: string) {
      return affiliatesApi.post<PostAffiliatesByIdUnblockResponse>(`/affiliates/${id}/unblock`);
    },
    // traffic block
    getAffiliateTrafficBlock(id: string) {
      return affiliatesApi.get<GetAffiliatesByIdTrafficBlockResponse>(
        `/affiliates/${id}/traffic-block`
      );
    },
    putAffiliateTrafficBlock(id: string, payload: PutAffiliatesByIdTrafficBlockData['body']) {
      return affiliatesApi.put<PutAffiliatesByIdTrafficBlockResponse>(
        `/affiliates/${id}/traffic-block`,
        payload
      );
    },
    deleteAffiliateTrafficBlock(id: string) {
      return affiliatesApi.delete<DeleteAffiliatesByIdTrafficBlockResponse>(
        `/affiliates/${id}/traffic-block`
      );
    },
    revokeAffiliate(id: string) {
      return affiliatesApi.post<PostAffiliatesByIdRevokeApproveResponse>(`/affiliates/${id}/revoke-approve`);
    },
    activateAffiliate(id: string) {
      return affiliatesApi.post<PostAffiliatesByIdManualEmailVerificationResponse>(`/affiliates/${id}/manual-email-verification`);
    },
    createPaymentAffiliate(id: string) { // / new method
      return affiliatesApi.post<PostAffiliatesByIdCreatePaymentResponse>(`/affiliates/${id}/create-payment`);
    },
    resetTotp(id: string) { // / new method
      return affiliatesApi.post<PostAffiliatesByIdResetTotpResponse>(`/affiliates/${id}/reset-totp`);
    },
    postChangeEmail(id: string, email: PostAffiliatesByIdUpdateEmailData['body']) { // / new method
      return affiliatesApi.post<PostAffiliatesByIdUpdateEmailResponse>(`/affiliates/${id}/update-email`, {
        email,
      });
    },
    postAffiliateRequestKyc(id: string) {
      return affiliatesApi.post<PostAffiliatesByIdRequestKycResponse>(`/affiliates/${id}/request-kyc`);
    },
    postAffiliateSkipKyc(id: string) {
      return affiliatesApi.post<PostAffiliatesByIdSkipKycResponse>(`/affiliates/${id}/skip-kyc`);
    },
    // createPayment(id) { // / deprecated
    //   return affiliatesApi.post(`/affiliates/${id}/schedule-payment-creation`);
    // },
    getPaymentsReportInfo(id: string, params: GetAffiliatesByIdPaymentsReportData['query']) {
      return affiliatesApi.get<GetAffiliatesByIdPaymentsReportResponse>(`/affiliates/${id}/payments-report`, { params });
    },
    getPaymentsReportCpaPlayersInfo(id: string, params: GetAffiliatesByIdPaymentsReportCpaPlayersData['query']) {
      return affiliatesApi.get<GetAffiliatesByIdPaymentsReportCpaPlayersResponse>(`/affiliates/${id}/payments-report/cpa-players`, { params });
    },

    getAffiliateNotes(id: string) {
      return affiliatesApi.get<GetAffiliateNotesResponse>(`/affiliate-notes?affiliate_id=${id}`);
    },
    postAffiliateNote(params: PostAffiliateNotesData['body']) {
      return affiliatesApi.post<PostAffiliateNotesResponse>('/affiliate-notes', params);
    },
    putAffiliateNote(id: string, params: PutAffiliateNotesByIdData['body']) {
      return affiliatesApi.put<PutAffiliateNotesByIdResponse>(`/affiliate-notes/${id}`, params);
    },
    deleteAffiliateNote(id: string) {
      return affiliatesApi.delete<DeleteAffiliateNotesByIdResponse>(`/affiliate-notes/${id}`);
    },

    getRotationGroupsForAffiliate(id: string) {
      return affiliatesApi.get<GetAffiliatesByIdRotationGroupsResponse>(`/affiliates/${id}/rotation-groups`);
    },

    addRotationGroupsForAffiliate(id: string, payload: PostAffiliatesByIdRotationGroupsData['body']) {
      return affiliatesApi.post<PostAffiliatesByIdRotationGroupsResponse>(`/affiliates/${id}/rotation-groups`, payload);
    },

    deleteRotationGroupsForAffiliate(id: string, groupId: string) {
      return affiliatesApi.delete<DeleteAffiliatesByIdRotationGroupsBySecondaryRotationGroupIdResponse>(
        `/affiliates/${id}/rotation-groups/${groupId}`
      );
    },

    setPrimeryRotationGroupsForAffiliate(id: string, groupId: string) {
      return affiliatesApi.post<PostAffiliatesByIdRotationGroupsBySecondaryRotationGroupIdSetAsPrimaryResponse>(
        `/affiliates/${id}/rotation-groups/${groupId}/set-as-primary`,
      );
    },
    updateAffiliateReferralProgram(payload: PostAffiliatesRearrangeReferralProgramData['body']) {
      return affiliatesApi.post<PostAffiliatesRearrangeReferralProgramResponse>(
        '/affiliates/rearrange-referral-program',
        payload
      );
    },
    updateAffiliateReferralProgramCount(payload: PostAffiliatesRearrangeReferralProgramCountData['body']) {
      return affiliatesApi.post<PostAffiliatesRearrangeReferralProgramCountResponse>(
        '/affiliates/rearrange-referral-program/count',
        payload
      );
    },
    availableAffiliateReferralProgram(
      body: PostAffiliatesRearrangeReferralProgramAvailableAffiliatesData['body'],
      params: PostAffiliatesRearrangeReferralProgramAvailableAffiliatesData['query']
    ) {
      return affiliatesApi.post<PostAffiliatesRearrangeReferralProgramAvailableAffiliatesResponse>(
        '/affiliates/rearrange-referral-program/available-affiliates',
        body,
        { params }
      );
    },

    getAffiliateReferralProgram(
      id: string,
      params: GetAffiliatesByIdUpdateReferralProgramAvailableAffiliatesData['query']
    ) {
      return affiliatesApi.get<GetAffiliatesByIdUpdateReferralProgramAvailableAffiliatesResponse>(
        `affiliates/${id}/update-referral-program/available-affiliates`,
        { params }
      );
    },
    putAffiliatePublicProfile(id: string, params: PutAffiliatesByIdPublicProfileData['body']) {
      return affiliatesApi.put<PutAffiliatesByIdPublicProfileResponse>(`/affiliates/${id}/public-profile`, params);
    },
    deleteAffiliatePublicProfile(id: string) {
      return affiliatesApi.delete<DeleteAffiliatesByIdPublicProfileResponse>(`/affiliates/${id}/public-profile`);
    },

    getAffiliateKpiBonuses(params: GetAffiliateKpiBonusesData['query']) {
      return affiliatesApi.get<GetAffiliateKpiBonusesResponse>('/affiliate-kpi-bonuses', { params });
    },
    postAffiliateKpiBonuses(payload: PostAffiliateKpiBonusesData['body']) {
      return affiliatesApi.post<PostAffiliateKpiBonusesResponse>('/affiliate-kpi-bonuses', payload);
    },
    putAffiliateKpiBonuses(id: string, payload: PutAffiliateKpiBonusesByIdData['body']) {
      return affiliatesApi.put<PutAffiliateKpiBonusesByIdResponse>(`/affiliate-kpi-bonuses/${id}`, payload);
    },
    cancelAffiliateKpiBonuses(id: string) {
      return affiliatesApi.post<PostAffiliateKpiBonusesByIdCancelResponse>(`/affiliate-kpi-bonuses/${id}/cancel`);
    },
    getAffiliateKpiBonusTypes() {
      return affiliatesApi.get<GetAffiliateKpiBonusesAvailableTypesResponse>('/affiliate-kpi-bonuses/available-types');
    },

    // affiliate monitoring
    getAffiliateMonitoring(params: GetAffiliateMonitoringData['query']) {
      return affiliatesApi.get<GetAffiliateMonitoringResponse>('/affiliate-monitoring', { params });
    },
    postAffiliateMonitoring(params: PostAffiliateMonitoringData['body']) {
      return affiliatesApi.post<PostAffiliateMonitoringResponse>('/affiliate-monitoring', params);
    },
    deleteAffiliateMonitoring(id: string) {
      return affiliatesApi.delete<DeleteAffiliateMonitoringByIdResponse>(`/affiliate-monitoring/${id}`);
    },
    putAffiliateMonitoring(id: string, payload: PutAffiliateMonitoringByIdData['body']) {
      return affiliatesApi.put<PutAffiliateMonitoringByIdResponse>(`/affiliate-monitoring/${id}`, payload);
    },
  };
}

